import React from 'react';

export const ConversationsIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.924 11A5.167 5.167 0 016.78 8.879a5.127 5.127 0 01-.646-3.891c.079-.344.192-.674.335-.988m6.454 7c.27-.098.535-.221.792-.368l2.79 1.334c.049.02.104.034.152.034.09 0 .179-.034.24-.103a.347.347 0 00.07-.392L15.633 8.7c.447-.777.68-1.657.68-2.557a5.09 5.09 0 00-1.512-3.637A5.122 5.122 0 0011.166 1h-.014A5.15 5.15 0 006.47 4m6.454 7c-.309.897-.924 2.5-2.424 3.5s-4.365 1-6 0L1 16l1.5-3.5C1.833 11.333 1 8.643 3 6.143 4.325 4.486 6.135 4.06 6.47 4"
            stroke="currentColor"
        />
        <ellipse rx=".608" ry=".6" transform="matrix(-1 0 0 1 4.747 10.1)" fill="currentColor" />
        <ellipse rx=".608" ry=".6" transform="matrix(-1 0 0 1 7.18 10.1)" fill="currentColor" />
        <ellipse cx="8.786" cy="6.1" rx=".608" ry=".6" fill="currentColor" />
        <ellipse cx="13.651" cy="6.1" rx=".608" ry=".6" fill="currentColor" />
        <ellipse cx="11.219" cy="6.1" rx=".608" ry=".6" fill="currentColor" />
    </svg>
);
